var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"title-container"},[_c('h1',{staticClass:"title2"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }